import React, { useState, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Stepper } from "@ann/web-components";
import { CreationTypeContainer, StepperContainer } from "./CreationType.styled";
import { CREATE_ROLE_STEPS, STEP_IDS } from "../../constants/createRoleSteps";
import { Filters, RoleList } from "./components";

// Mock data - será reemplazado con datos reales más adelante
const MOCK_ROLES = [
  {
    id: "role-1",
    icon: "visibility",
    title: "Admin Role",
    description: "Full access to all features and settings. Can manage users, roles, and workspace configuration.",
    userCount: 34
  },
  {
    id: "role-2",
    icon: "person",
    title: "User Role",
    description: "Standard user access with permissions controlled by assigned roles and groups.",
    userCount: 12
  },
  {
    id: "role-3",
    icon: "edit",
    title: "Editor Role",
    description: "Can create and edit content but cannot manage users or change workspace settings.",
    userCount: 8
  },
  {
    id: "role-4",
    icon: "read_more",
    title: "Viewer Role",
    description: "Read-only access. Can view content but cannot create, edit, or delete anything.",
    userCount: 25
  },
  {
    id: "role-5",
    icon: "settings",
    title: "Manager Role",
    description: "Can manage team members and content within assigned departments or groups.",
    userCount: 5
  },
  {
    id: "role-6",
    icon: "security",
    title: "Security Role",
    description: "Specialized permissions for security settings, audit logs, and compliance management.",
    userCount: 3
  }
];

const CreationType = ({ onRoleSelect }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("name");
  const [orderDirection, setOrderDirection] = useState("asc");

  const handleSelectStep = (stepId) => {
    switch (stepId) {
      case STEP_IDS.CREATION_TYPE:
        navigate("/v2/user-management/create-role");
        break;
      case STEP_IDS.DETAILS:
        navigate("/v2/user-management/create-role/details");
        break;
      default:
        break;
    }
  };

  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value);
  }, []);

  const handleSortChange = useCallback((value) => {
    setSortOption(value);
  }, []);

  const handleOrderChange = useCallback((currentOrder) => {
    // Toggle order: asc -> desc, desc -> asc
    const newOrder = currentOrder === 'asc' ? 'desc' : 'asc';
    setOrderDirection(newOrder);
  }, []);

  // Filter and sort roles based on search and sort options
  const filteredAndSortedRoles = useMemo(() => {
    let filtered = MOCK_ROLES;

    // Apply search filter
    if (searchTerm && searchTerm.trim() !== "") {
      const searchLower = searchTerm.toLowerCase().trim();
      filtered = MOCK_ROLES.filter(
        (role) =>
          role.title.toLowerCase().includes(searchLower) ||
          role.description.toLowerCase().includes(searchLower)
      );
    }

    // Apply sorting
    const sorted = [...filtered].sort((a, b) => {
      let comparison = 0;

      switch (sortOption) {
        case "name":
          comparison = a.title.localeCompare(b.title);
          break;
        case "userCount":
          comparison = a.userCount - b.userCount;
          break;
        default:
          comparison = a.title.localeCompare(b.title);
          break;
      }

      return orderDirection === "asc" ? comparison : -comparison;
    });

    return sorted;
  }, [searchTerm, sortOption, orderDirection]);

  return (
    <CreationTypeContainer>
      <StepperContainer>
        <Stepper
          activeStep={STEP_IDS.CREATION_TYPE}
          onSelectStep={handleSelectStep}
          steps={CREATE_ROLE_STEPS}
        />
      </StepperContainer>
      <Filters
        onSearchChange={handleSearchChange}
        onSortChange={handleSortChange}
        onOrderChange={handleOrderChange}
        selectedSortOption={sortOption}
        orderDirection={orderDirection}
      />
      <RoleList
        onRoleSelect={onRoleSelect}
        roles={filteredAndSortedRoles}
      />
    </CreationTypeContainer>
  );
};

export default CreationType;

